// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel__pagination {\n  display: flex;\n  justify-content: center;\n  list-style: none;\n}\n\n.carousel__pagination-button {\n  margin: 5px;\n  width: 10px;\n  height: 5px;\n  border: 0;\n  cursor: pointer;\n  background-color: var(--carousel-color-secondary);\n}\n\n.carousel__pagination-button--active {\n  background-color: var(--carousel-color-primary);\n}\n", ""]);
// Exports
module.exports = exports;
